module.exports = __webpack_public_path__ + "img/Badge.477a154f.svg";